var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6218 9C22.2897 3.82432 17.5914 0 11.9999 0C6.40836 0 1.71006 3.82432 0.37793 9C1.71006 14.1757 6.40836 18 11.9999 18C17.5914 18 22.2897 14.1757 23.6218 9ZM2.45711 9C3.7312 13.0581 7.52431 16 11.9999 16C16.4754 16 20.2686 13.0581 21.5426 9C20.2686 4.94186 16.4754 2 11.9999 2C7.52431 2 3.7312 4.94186 2.45711 9ZM11.9999 13C14.209 13 15.9999 11.2091 15.9999 9C15.9999 6.79086 14.209 5 11.9999 5C9.79074 5 7.99988 6.79086 7.99988 9C7.99988 11.2091 9.79074 13 11.9999 13ZM11.9999 11C13.1044 11 13.9999 10.1046 13.9999 9C13.9999 7.8954 13.1044 7 11.9999 7C10.8953 7 9.99988 7.8954 9.99988 9C9.99988 10.1046 10.8953 11 11.9999 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye2);
export default __webpack_public_path__ + "static/media/eye2.ab4b7fbf496c43325b420e1c2f0409ba.svg";
export { ForwardRef as ReactComponent };